var map = {
	"./stage_name_chirpie.png": 63040,
	"./stage_name_dali.png": 22110,
	"./stage_name_donut.png": 18322,
	"./stage_name_echo_delay.png": 73636,
	"./stage_name_fann.png": 80339,
	"./stage_name_fluffy.png": 82821,
	"./stage_name_fuyu.png": 469,
	"./stage_name_karl.png": 37491,
	"./stage_name_lulu.png": 54405,
	"./stage_name_maggie.png": 71920,
	"./stage_name_marsh.png": 68657,
	"./stage_name_pisces.png": 17726,
	"./stage_name_rappit.png": 2505,
	"./stage_name_sandy.png": 72583,
	"./stage_name_shojo.png": 38953,
	"./stage_name_spike.png": 65240,
	"./stage_name_wako.png": 99547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28991;